import { makeStyles } from '@material-ui/core/styles';
import { AssignIcon } from '../../../../components/Icon';
import webDesign from '../../../../static/images/template.png';
import { i18n } from '../../../../language';
import useMobile from '../../../../utils/useMobile';
import { onKeyUpEnterOrSpace } from '../../../../utils';

const useStyles = makeStyles((theme) => ({
  root: ({ showDefaultText, showFullName }) => ({
    display: 'flex',
    width: showFullName ? 'auto' : '18.25rem',
    minWidth: showFullName ? '18.25rem' : '12rem',
    height: '5.438rem',
    backgroundColor: theme.palette.font.white,
    borderRadius: '0.9375rem',
    boxShadow: '0 0.41875rem 1rem 0 rgba(0, 0, 0, 0.04)',
    padding: '1.125rem 1.125rem 1.063rem 1.875rem',
    position: 'relative',
    '&:hover': {
      cursor: 'pointer',
    },
    alignItems: showDefaultText ? 'flex-start' : 'center',
  }),
  img: {
    width: 'auto',
    height: '3.25rem',
    marginRight: '1.25rem',
  },
  foot: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: '0.313rem',
  },
  title: ({ showFullName }) => ({
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: theme.palette.font.main,
    width: showFullName ? 'auto' : '12rem',
    fontWeight: 'bold',
    overflow: 'hidden',
    textOverflow: showFullName ? 'unset' : 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  smalltitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: theme.palette.font.sub,
    fontWeight: '500',
  },
  background: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.font.main,
    position: 'absolute',
    top: '0',
    left: '0',
    borderRadius: '0.9375rem',
    boxShadow: '0 0.41875rem 1rem 0 rgba(0, 0, 0, 0.04)',
    opacity: '0.27',
  },
  edit: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    padding: '1.25rem 0 1.188rem',
  },
  editButton: {
    width: '10.313rem',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '0.625rem',
    padding: '0.875rem 0 0.875rem 1.25rem',
    display: 'flex',
    margin: '0 auto',
  },
  editIcon: {
    fontSize: '1.25rem',
    color: theme.palette.font.white,
    marginRight: '0.312rem',
  },
  editContext: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
  },
}));

export default function Card({ title, Click, id, flag, setFlag, showDefaultText = true, showFullName = false }) {
  const classes = useStyles({ showDefaultText, showFullName });
  const [isPad] = useMobile();

  const handleClick = () => {
    if (isPad) {
      if (id === flag) {
        Click();
      } else {
        setFlag(id);
      }
    } else {
      Click();
    }
  };

  return (
    <div
      className={classes.root}
      onClick={handleClick}
      id={`DutyAssign-div-afr-${id}`}
      onMouseEnter={() => {
        !isPad && setFlag(id);
      }}
      onMouseLeave={() => {
        !isPad && setFlag(null);
      }}
      tabIndex={0}
      onKeyUp={(e) => onKeyUpEnterOrSpace(e, handleClick)}
    >
      <img className={classes.img} src={webDesign} alt="" />
      <div className={classes.foot}>
        <div className={classes.title}>{title}</div>
        {showDefaultText && (
          <div className={classes.smalltitle}>{i18n.t('DUTYASSIGN_PLANNER_ADD_TEMPLATE_DEFAULT')}</div>
        )}
      </div>
      {id === flag && (
        <div>
          <div
            className={classes.background}
            onMouseOut={() => !isPad && setFlag(null)}
            id="DutyAssign-div-afs"
            onBlur={() => !isPad && setFlag(null)}
          />
          <div className={classes.edit}>
            <div className={classes.editButton}>
              <AssignIcon className={classes.editIcon} />
              <div className={classes.editContext}>{i18n.t('DUTYASSIGN_MYTEMPLATE_BODY_EDIT')}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
